<template>
  <div v-if="isShowReferAFriendDiscount" class="opc-cart__referral_discount" >
    <div class="opc-cart__referral_discount-info">
      <h2 class="opc-cart__referral_discount-info-title">
        {{ $t('billing.referral.referral_discount') }}
      </h2>
    </div>
    <div class="opc-cart__referral_discount-price">{{ discountAmount }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  getReferAFriendDiscountAmount,
} from '@/views/config/shopping-cart/refer-a-friend-discount/refer-a-friend-discount';

export default {
  computed: {
    ...mapGetters([
      'isEligibleForReferAFriendDiscount',
      'referAFriendRewardValue',
    ]),
    discountAmount() {
      return this.$money(getReferAFriendDiscountAmount());
    },
    isShowReferAFriendDiscount() {
      return this.isEligibleForReferAFriendDiscount;
    },
  },
};
</script>

<style lang="scss">
@import './index.scss';
</style>
